export const Features = {
  RESET_PASSWORD: false,
  SUPPLEMENTARY_WORK: false,
  MORE_INFO_LICENSES: true,
  VIATICOS: false,
  
  TAREAS_PENDIENTES: false,
  NOTIFICACIONES: true,
  ADELANTO_VACACIONAL: true,
  AUTO_PARTICULAR: false,
};
